import React from 'react'
import styled from '@emotion/styled'
import { Tag } from '@xfers/design-system'

type Props = {
  variant?: 'regular' | 'mini'
  right?: string
}

const NewLabel = ({ variant, right = '-22px' }: Props) => {
  switch (variant) {
    case 'mini':
      return (
        <MiniContainer right={right}>
          <Tag variant="filled" type="positive">
            <strong>NEW</strong>
          </Tag>
        </MiniContainer>
      )
    default:
      return (
        <Tag variant="filled" type="positive">
          <strong>New</strong>
        </Tag>
      )
  }
}

export default NewLabel

const MiniContainer = styled.div<{ right: string }>`
  position: absolute;
  bottom: -10px;
  right: ${(props) => props.right};
  z-index: 1;
  transform: scale(0.35);
  transform-origin: center;

  span {
    overflow: hidden;
    font-size: 16px;
  }
`
